define('Inspiredspace.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function InspiredspaceModel () {
        SCModel.call(this);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/Main/SuiteScript2/Inspiredspace.ei1.Main.Service.ss"
                ), true
            )
        }
    }
 
    InspiredspaceModel.prototype = Object.create(SCModel.prototype);
    InspiredspaceModel.prototype.constructor = InspiredspaceModel;
 
    return InspiredspaceModel
})
